<template>
  <v-container grid-list-xl pa-0>
    <h2 class="my-3 title">Switch Utilities</h2>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="250">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-dumpster</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Garbage</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>
              Republic Services: <a href="tel:+1-702-735-5151">702-735-5151</a>
            </div>
            <div>Recycling: <a href="tel:+1-702-735-5151">702-735-5151</a></div>
            <div>
              <a href="//www.republicserviceslasvegas.com">
                www.republicserviceslasvegas.com
              </a>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="250">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-burn</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Gas</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>
              Southwest Gas: <a href="tel:+1-877-860-6020">877-860-6020</a>
            </div>
            <div><a href="//www.swgas.com">www.swgas.com</a></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="300">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-plug</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Power</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>
              NV Energy Customer Service:
              <a href="tel:+1-775-834-4444">775-834-4444</a>
            </div>
            <div>
              Outage Reporting: <a href="tel:+1-775-834-4100">775-834-4100</a>
            </div>
            <div><a href="//www.nvenergy.com">www.nvenergy.com</a></div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="300">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-tv-retro</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Television</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>Cox Cable: <a href="tel:+1-702-383-4000">702-383-4000</a></div>
            <div><a href="//lasvegas.cox.net">lasvegas.cox.net</a></div>
            <div class="pt-2">
              DirecTV: <a href="tel:+1-888-777-2454">888-777-2454</a>
            </div>
            <div><a href="//www.directv.com">www.directv.com</a></div>
            <div class="pt-2">
              Dish: <a href="tel:+1-888-926-6165">888-926-6165</a>
            </div>
            <div><a href="//www.dish.com">www.dish.com</a></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="380">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-phone</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Telephone</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>
              CenturyLink:
              <a href="//www.centurylink.com">www.centurylink.com</a>
            </div>
            <div>Sprint: <a href="//www.sprint.com">www.sprint.com</a></div>
            <div>
              Cox Communications: <a href="//www.cox.com">www.cox.com</a>
            </div>
            <div class="pt-3"><strong>Cell Phone Providers</strong></div>
            <div>
              Check out the
              <a
                href="http://lasvegasnvcoc.weblinkconnect.com/CWT/External/WCPages/WCDirectory/Directory.aspx?CategoryID=546&Title=Telephone+Companies&AdKeyword=Telephone+Companies"
              >
                Chamber Business Directory
              </a>
            </div>
            <div class="pt-3"><strong>Long Distance Service</strong></div>
            <div>AT&T: <a href="//www.att.com">www.att.com</a></div>
            <div>
              MCI Telecommunications: <a href="//www.mci.com">www.mci.com</a>
            </div>
            <div>
              Sprint Business:
              <a href="//www.sprintbusiness.com">www.sprintbusiness.com</a>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card class="elevation-2" height="380">
          <div class="text-xs-center pt-4">
            <v-icon x-large>fas fa-shower</v-icon>
          </div>
          <v-card-title primary-title>
            <h3 class="title mb-0 text-uppercase">Water & Sewer</h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <div>
              Las Vegas Valley Water District:
              <a href="tel:+1-702-870-4194">702-870-4194</a>
            </div>
            <div>
              Customer Service: <a href="tel:+1-800-252-2011">800-252-2011</a>
            </div>
            <div>
              <strong>
                Call before you dig:
              </strong>
              <a href="tel:=1-800-227-2600">800-227-2600</a>
            </div>
            <div><a href="//www.lvvwd.com">www.lvvwd.com</a></div>
            <div class="pt-3">
              Henderson Water: <a href="tel:+1-702-267-5900">702-267-5900</a>
            </div>
            <div>
              North Las Vegas Water:
              <a href="tel:+1-702-633-1275">702-633-1275</a>
            </div>
            <div class="pt-3">Clark County Reclamation District</div>
            <div>
              <a href="//www.cleanwaterteam.com">www.cleanwaterteam.com</a>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ResourceUtilities',
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
